"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _Helmet = require("../meta/Helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.ZNA;
var DEBUG_CONSOLE = false;
var IS_TRANSACTION_LEVEL = 'TransactionLevel';
var IS_CATEGORY_LEVEL = 'CategoryLevel';
var IS_PROPERTYTYPES_LEVEL = 'PropertyTypeLevel';
var IS_ZONE_NON_ADMIN_LEVEL = 'ZoneNonAdminLevel';
var IS_SUB_ZONE_NON_ADMIN_LEVEL = 'SubZoneNonAdminLevel';
var IS_BUILDINDCONDITIONS_LEVEL = 'BuildingConditionLevel';
var IS_NON_ADMIN_PREFIX_LEVEL = 'NonAdminPrefixLevel';
var IS_LICENSETYPE_LEVEL = 'LicenseLevel';
var CHECK_LEVEL_LICENSETYPE_OLDPYTPES = {
  license_type_groups: true
};
var CHECK_LEVEL_ZNA_SUB = {
  nonAdminSubZone: true,
  license_type_groups: CHECK_LEVEL_LICENSETYPE_OLDPYTPES
};
var CHECK_LEVEL_ZNA = {
  nonAdminZone: true,
  nonAdminSubZone: CHECK_LEVEL_ZNA_SUB,
  license_type_groups: CHECK_LEVEL_LICENSETYPE_OLDPYTPES
};
var CHECK_LEVEL_BUILDING_CONDITIONS = {
  nonAdminZone: CHECK_LEVEL_ZNA
};
var CHECK_LEVEL_PROPERTYTYPES = {
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS,
  nonAdminZone: CHECK_LEVEL_ZNA
};
var CHECK_LEVEL_CATEGORY = {
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS,
  nonAdminZone: CHECK_LEVEL_ZNA
};
var CHECK_LEVEL_TRANSACTION = {
  category: CHECK_LEVEL_CATEGORY,
  propertyTypes: CHECK_LEVEL_PROPERTYTYPES,
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS,
  nonAdminZone: CHECK_LEVEL_ZNA
};
var CHECK_LEVEL_NON_ADMIN_PREFIX_LEVEL = {
  transaction: CHECK_LEVEL_TRANSACTION,
  propertyTypes: CHECK_LEVEL_PROPERTYTYPES
};
var CHECK_LEVEL = {
  nonAdminZonePrefix: CHECK_LEVEL_NON_ADMIN_PREFIX_LEVEL
};

var NonAdministrativeZonesSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(NonAdministrativeZonesSeoManager, _BaseSeoManager);

  var _super = _createSuper(NonAdministrativeZonesSeoManager);

  function NonAdministrativeZonesSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, NonAdministrativeZonesSeoManager);

    _this = _super.call(this, domain, lang);
    _this.immotype = undefined;
    _this.encode_parts = {};
    _this.encode_qs = [];
    _this.locations = [];
    _this.num_levels = 0;
    _this.max_levels = 0;
    _this.level_prec = null;
    _this.tree = null;
    return _this;
  }

  _createClass(NonAdministrativeZonesSeoManager, [{
    key: "debugConsole",
    value: function debugConsole(caption, value) {
      if (!DEBUG_CONSOLE) {
        return false;
      }
    }
  }, {
    key: "decodeLevel",
    value: function decodeLevel(level, value) {
      var _this2 = this;

      this.debugConsole("\n* decodeLevel");
      this.debugConsole('level', level);
      this.debugConsole('value', value);

      if (!this.isValidDecode()) {
        return;
      }

      this.valid_levels["level".concat(level)] = false;
      this.level_prec = level === 1 ? null : this.data.seo_decode_type["level".concat(level - 1)];

      var getCheckLevel = function getCheckLevel(dispayValue) {
        _this2.debugConsole('is', dispayValue);

        Object.keys(_this2.data.seo_decode_type).map(function (key, idx) {
          var levelName = _this2.data.seo_decode_type[key];

          if (idx === 0) {
            _this2.tree = Object.assign({}, CHECK_LEVEL[levelName]);
          } else {
            _this2.tree = _this2.tree[levelName];
          }
        });

        if (_this2.tree) {
          _this2.valid_levels["level".concat(level)] = true;
        } else {
          _this2.debugConsole("valid_level_".concat(level), "".concat(_this2.valid_levels["level".concat(level)], ", ").concat(_this2.data.seo_decode_type["level".concat(level)]));
        }
      };

      if (this.isNonAdministrativePrefixLevel(value, level)) {
        getCheckLevel(IS_NON_ADMIN_PREFIX_LEVEL);
      } else if (this.isTransactionLevel(value, level)) {
        getCheckLevel(IS_TRANSACTION_LEVEL);
      } else if (this.isCategoryLevel(value, level)) {
        getCheckLevel(IS_CATEGORY_LEVEL);
      } else if (this.isPropertyTypeLevel(value, level)) {
        getCheckLevel(IS_PROPERTYTYPES_LEVEL);
      } else if (this.isBuildingConditionLevel(value, level)) {
        getCheckLevel(IS_BUILDINDCONDITIONS_LEVEL);
      } else if (this.isZoneNonAdminGeoLevel(value, level)) {
        getCheckLevel(IS_ZONE_NON_ADMIN_LEVEL);
      } else if (this.isLicenseTypeLevel(value, level)) {
        getCheckLevel(IS_LICENSETYPE_LEVEL);
      } else if (this.isZoneNonAdminSubZoneGeoLevel(value, level)) {
        getCheckLevel(IS_SUB_ZONE_NON_ADMIN_LEVEL);
      }

      this.debugConsole("valid_level_".concat(level), "".concat(this.valid_levels["level".concat(level)], "\n"));
    }
  }, {
    key: "decode",
    value: function decode(url) {
      return _get(_getPrototypeOf(NonAdministrativeZonesSeoManager.prototype), "decode", this).call(this, url, MANAGER_TYPE);
    }
  }, {
    key: "isNonAdministrativePrefixLevel",
    value: function isNonAdministrativePrefixLevel(value, level) {
      if (value === 'geo') {
        this.addData('zna_prefix', value);
        this.addDecodeData("level".concat(level), 'nonAdminZonePrefix');
        return true;
      }

      return false;
    }
  }, {
    key: "isTransactionLevel",
    value: function isTransactionLevel(value, level) {
      if (_SeoManagerHelpers.TR_DECODE_FOR_ESAPI[this.lang][value] !== undefined) {
        this.addData('tr', _SeoManagerHelpers.TR_DECODE_FOR_ESAPI[this.lang][value]);
        this.addDecodeData("level".concat(level), 'transaction');
        return true;
      }

      return false;
    }
  }, {
    key: "isCategoryLevel",
    value: function isCategoryLevel(value, level) {
      if (_SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][value]) {
        var ptgDecode = _SeoManagerHelpers.DECODE_PROPERTYTYPEGROUP_SEO_URL[this.lang][value] || value;
        this.addData('category', _SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][value]);
        this.addData('propertyTypeGroup', ptgDecode);
        this.addDecodeData("level".concat(level), 'category');
        return true;
      }

      return false;
    }
  }, {
    key: "isPropertyTypeLevel",
    value: function isPropertyTypeLevel(value, level) {
      if (this.level_prec === 'nonAdminZone') {
        return false;
      }

      var obj = (0, _SeoManagerHelpers.getObjByCategoryImmotype)(this.lang, value);

      if (obj) {
        this.immotype = obj;
        this.addData('propertyTypes', obj);
        this.addData('category', obj.category);
        var ptgDecode = _SeoManagerHelpers.DECODE_PROPERTYTYPEGROUP_SEO_URL[this.lang][obj.category] || obj.category;
        this.addData('propertyTypeGroup', ptgDecode);
        this.addDecodeData("level".concat(level), 'propertyTypes');
        return true;
      }

      if (!this.data.category && (!this.data || !this.data.agency)) {
        this.addData('category', _SeoManagerHelpers.DEFAULT_CATEGORY);
        this.addData('propertyTypeGroup', _SeoManagerHelpers.DEFAULT_PROPERTYTYPEGROUP);
      }

      return false;
    } // to check for ristrutturato

  }, {
    key: "isBuildingConditionLevel",
    value: function isBuildingConditionLevel(value, level) {
      var buildingConds = (0, _SeoManagerHelpers.getBuildingConditions)(this.lang, value);

      if (buildingConds) {
        this.addData('buildingCondition', buildingConds);
        this.addDecodeData("level".concat(level), 'buildingCondition');
        return true;
      }

      return false;
    }
  }, {
    key: "isZoneNonAdminGeoLevel",
    value: function isZoneNonAdminGeoLevel(value, level) {
      // const geoType = decodeGeoType(value, level);
      if (this.level_prec !== 'buildingCondition' && this.level_prec !== 'propertyTypes' && this.level_prec !== 'category') {
        return false;
      }

      var geoType = {
        l130: {
          nonadminzone: value
        }
      };
      this.addDecodeData("level".concat(level), 'nonAdminZone');
      this.addData('geo', geoType);
      return true;
    }
  }, {
    key: "isZoneNonAdminSubZoneGeoLevel",
    value: function isZoneNonAdminSubZoneGeoLevel(value, level) {
      // const geoType = decodeGeoType(value, level);
      if (this.level_prec !== 'nonAdminZone') {
        return false;
      }

      var geoType = _objectSpread({}, this.data.geo, {
        l132: {
          nonadminsubzone: value
        }
      });

      this.addDecodeData("level".concat(level), 'nonAdminSubZone');
      this.addData('geo', geoType);
      return true;
    }
  }, {
    key: "isLicenseTypeLevel",
    value: function isLicenseTypeLevel(value, level) {
      var ltKeys = _objectSpread({}, _SeoManagerHelpers.LICENSE_TYPE_GROUPS_DECODE, {}, _SeoManagerHelpers.LICENSE_TYPE_CUSTOM_SLUGS_TRANSLATIONS);

      var key = ltKeys[value];

      if (key) {
        var ltGroup = (0, _SeoManagerHelpers.getLicenseTypeGroupFromKey)(key);
        this.addData('license_type_groups', ltGroup);
        this.addDecodeData("level".concat(level), 'license_type_groups'); // this.data.queryObject = Object.assign({}, this.data.queryObject || null, { license_type_groups: value });

        return true;
      }

      return false;
    }
  }, {
    key: "createSeoData",
    value: function createSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          seoParams = _ref.seoParams,
          isSrpUrl = _ref.isSrpUrl;

      this.seo_data.seo = (0, _Helmet.getHelmet)({
        domain: this.domain,
        lang: this.lang,
        seodata: this.data,
        locations: locations,
        count: total_listings,
        seoParams: seoParams,
        pageType: 'NonAdministrativeZones',
        isSrpUrl: isSrpUrl
      });
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: ['geo']
      };
    }
  }]);

  return NonAdministrativeZonesSeoManager;
}(_BaseSeoManager2["default"]);

var _default = NonAdministrativeZonesSeoManager;
exports["default"] = _default;